import { useMutation, useQueryClient } from '@tanstack/react-query';

import { accountApi } from '../api';

interface UseRemoveUserDeviceParams {
  deviceGroupId: string;
  deviceId: string;
}

export const useRemoveUserDevice = () => {
  const queryClient = useQueryClient();

  const removeUserDevicesMutation = useMutation({
    mutationFn: ({ deviceGroupId, deviceId }: UseRemoveUserDeviceParams) => {
      return accountApi.removeDeviceV2(deviceGroupId, deviceId).then(({ data }) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.devices'] });
    },
  });

  return {
    removeUserDevice: removeUserDevicesMutation.mutateAsync,
    ...removeUserDevicesMutation,
  };
};
